import React, { useEffect, useState } from "react";
import { isTaskMantisDesktop } from "../desktopUpdate";
import "./DesktopUpdateModal.css";

/**
 * Settings row that shows the installed desktop version and checks for a
 * newer unsigned installer.
 *
 * @example
 * <DesktopUpdateSettingsRow />
 * // Renders "Check for updates" in Electron; nothing in the browser
 */
const DesktopUpdateSettingsRow = () => {
  const [version, setVersion] = useState("");
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    if (!isTaskMantisDesktop()) return undefined;
    let cancelled = false;
    window.starmeshDesktop
      .getVersion?.()
      .then((next) => {
        if (!cancelled) setVersion(String(next || "").trim());
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!isTaskMantisDesktop()) return null;

  const handleCheck = async () => {
    setChecking(true);
    try {
      await window.starmeshDesktop.checkForUpdates?.();
    } finally {
      setChecking(false);
    }
  };

  return (
    <section className="settings-general-section">
      <h3 className="settings-general-section__title">Desktop app</h3>
      <div className="desktop-update-settings-row">
        <div className="desktop-update-settings-row__copy">
          <div className="desktop-update-settings-row__label">Version</div>
          <p className="desktop-update-settings-row__description">
            {version ? version : "Installed desktop build"}
          </p>
        </div>
        <button
          type="button"
          className="desktop-update-settings-row__btn"
          onClick={() => void handleCheck()}
          disabled={checking}
        >
          {checking ? "Checking…" : "Check for updates"}
        </button>
      </div>
    </section>
  );
};

export default DesktopUpdateSettingsRow;
